import { EntidadeBase } from 'hay-core-react';
class UsuarioGrupoModel extends EntidadeBase {
  constructor() {
    super('usuariogrupo');
  }
}

export default new UsuarioGrupoModel();
